import React, {useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import { alertResponseMessage } from "../../actions/action-creators/response";
import { post_api_call, error_api_call, downloadBlobCreatedFile } from "../../actions/action-creators/common";
import FormDataExcel from "../../data/formData/hub/excel-upload";
import ValidationHelper from "../../helper/validation";
import ModalMaster from "../master";
const {
    fieldHubExcel,
    fieldValExcel,
    fieldValidExcel,
} = FormDataExcel;

function HubExcelModal(props) {
    const [showResModal, setShowResModal] = useState(false);
    const [filledData, setFilledData] = useState(fieldValExcel);
    const [isProcess, setIsProcess] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [formData, setFormData] = useState(fieldHubExcel);
    const [successData, setSuccessData] = useState([]);
    const [failedData, setFailedData] = useState([]);

    useEffect(() => {
        // if(props.isShow){
            setFilledData(fieldValExcel);
            setFormData(fieldHubExcel);
            setErrorData([]);
            setIsProcess(false);
            setFailedData([]);
            setSuccessData([]);
        // }
    }, [props.isShow]);// eslint-disable-line react-hooks/exhaustive-deps
    //Update Input
    const updateInput = (field, value) => {
        try{
            var updatedFormDetails = {...filledData};
            updatedFormDetails[field] = value;
            if(field === "excel_file"){
                // updatedFormDetails.excel_file_data = files;
                updatedFormDetails.excel_file_data = value.files;
                updatedFormDetails.excel_file = value?.value;
            }
            setFilledData({...updatedFormDetails});
        }catch(error){
          console.log(error)
        }
    }
    const _submitForm = async(e) => {
        try{
            e.preventDefault();
            setIsProcess(true);
            setErrorData([]);
            //Validation
            const validation = ValidationHelper.validation(filledData, fieldValidExcel).error;
            if(validation.length){
                setErrorData(validation);
                setIsProcess(false);
                return;
            }
            var apiFormData = new FormData();
            apiFormData.append('excel_file', filledData.excel_file_data[0]);
            apiFormData.append('create_type', 'excel');
            const apiData = await post_api_call(`opportunity/create`, apiFormData);
            // console.log(apiData, 'apiDataapiDataapiDataapiData')
            if(apiData.status === 200){
                alertResponseMessage({alert_type: apiData.failed_data.length ? 2 : 1, message: apiData.message});
                // Show Not Registered & Registered Data
                if(apiData.success_data.length > 0){
                    setSuccessData(apiData.success_data);
                    props._resetListing();
                }
                if(apiData.failed_data.length > 0){
                    setFailedData(apiData.failed_data);
                    //automatically download data in Excel File
                    const apiExcelData = await post_api_call('sample/failed',
                                                        {data: {
                                                            data: apiData.excel_data,
                                                            headers: apiData.headers,
                                                            sheet_name: "Opportunities"},
                                                        file_name: "Failed-Opportunity-Data.xlsx"
                                                    }, true, 'blob');
                    if(apiExcelData.status === 200){
                        downloadBlobCreatedFile(apiExcelData, `Failed-Opportunity-Data.xlsx`);
                    }
                }
                setShowResModal(true);
                // props._toggleModal(e, false);
            }
            setIsProcess(false);
        }catch(error){
            setIsProcess(false);
            console.error(error);
            alertResponseMessage({alert_type: 2, message: "Error Uploading Excel File! Please try after some times"});
            error_api_call({error: `modal/hub/excel-upload|_submitForm|${e}`});
        }
    }

    return (
      <>
        {(failedData.length > 0
            || successData.length > 0
        ) 
        ?
            <>
                <Modal dialogClassName="modal-70w modal-dialog-scrollable" show={showResModal} onHide={(e) => {setShowResModal(false); props._toggleModal(e, false);}} size="md" className="mod-custom team-detail" backdrop="static">
                    <Modal.Header closeButton>Excel Upload Result</Modal.Header>
                    <Modal.Body>
                        {/* Failed Data */}
                        {failedData.length > 0 && (
                            <fieldset>
                                <legend>Failed Opportunities Data ({failedData.length})</legend>
                                <div className={`row m-0 table-responsive table table-danger ${successData.length > 0 ? 'scroll-div-30vh' : ''}`}>
                                    <table className="table-bordered">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Excel Row No.</th>
                                                <th>Reason</th>
                                                <th>Organizer Name</th>
                                                <th>Title</th>
                                                <th>Opportunity Type</th>
                                                <th>Opportunity Sub Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {failedData.map((fail_data, fail_idx) => (
                                                <tr key={`failed_data_${fail_idx}`}>
                                                    <td>{fail_data.row_no}</td>
                                                    <td><b>{fail_data.reason}</b></td>
                                                    {fail_data.data.map((fail_stu_d, fail_stu_idx) => (
                                                        fail_stu_idx !== 2 && (
                                                        <td key={`fail_stu_${fail_stu_idx}`}>{fail_stu_d}</td>)
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        )}
                        {/* Success Data */}
                        {successData.length > 0 && (
                            <fieldset>
                                <legend>Added Opportunities ({successData.length})</legend>
                                <div className={`row m-0 table-responsive table table-success ${failedData.length > 0 ? 'scroll-div-30vh' : ''}`}>
                                    <table className="table-bordered">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Excel Row No.</th>
                                                <th>Reason</th>
                                                <th>Organizer Name</th>
                                                <th>Title</th>
                                                <th>Opportunity Type</th>
                                                <th>Opportunity Sub Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {successData.map((succ_data, succ_idx) => (
                                                <tr key={`success_data_${succ_idx}`}>
                                                    <td>{succ_data.row_no}</td>
                                                    <td><b>{succ_data.password}</b></td>
                                                    {succ_data.data.map((succ_stu_d, succ_stu_idx) => (
                                                        succ_stu_idx !== 2 && (
                                                        <td key={`succ_stu_${succ_stu_idx}`}>{succ_stu_d}</td>)
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="team-detail">
                        <button className="btn btn-secondary" onClick={(e) => {setShowResModal(false); props._toggleModal(e, false);}}>Close</button>
                    </Modal.Footer>
                </Modal>
            </>
        :
        <ModalMaster
            isShow={props.isShow}
            _toggleModal={(e, state) => props._toggleModal(e, state)}
            // modKey={activeEditForm}//new, edit
            formType={'excel_reg'}
            data={filledData}
            title={"Opportunity Addition"}
            _errorData={{excel_reg: errorData}}
            _isProcess={{excel_reg: isProcess}}
            // _updateInput= {(form_type, variable_type, input_type, field, value, files="") => updateInput(field, value, files)}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(field, value)}
            _submitForm={(e, form_type) => _submitForm(e)}
            _formData={[{form_type: 'excel_reg', label: 'Details', fields: [...formData]}]}
            selectOptions={{...props.selectOptions}}    
        />
        }
      </>
    );
}
  
export default HubExcelModal;